import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import Query from 'dashboard-services/api/Query';
import { globalActions } from 'primary-components';

import getApiConfig from 'api/ApiConfig';
import { dataSharingQueries } from 'queries/modules/datasharing';

const EMPTY_ARRAY = [];
export default (() => {
  const useProviders = () => {
    const dispatch = useDispatch(),
          getApiConfigLocal = useCallback(() => dispatch(getApiConfig()), [dispatch]),
          getQueryBuilder = useCallback(() => 
            new Query.Builder(getApiConfigLocal())
              .withFetching(false)
              .withShouldDisplayError(false)
          , [getApiConfigLocal]),
          { data: providers = EMPTY_ARRAY } = dataSharingQueries.useGetProducers({ getQueryBuilder, includeSelfProducer: true })

    useEffect(() => {
      dispatch(globalActions.onChange(providers, "providers"))
    }, [dispatch, providers])
  }

  return {
    useProviders
  }
})()